<template>
	<div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("rooms") }}</h1>
			</div>
			<div class="col-7 mb-4">
				<router-link to="/timetables/rooms/add" class="float-right btn btn-primary">
					<b-icon icon="plus"></b-icon> {{ $t("new") }}
				</router-link>
			</div>
		</div>
        <div class="row">
            <div class="col-md-12">
                <Table
                    :loading="loading"
                    :submitting="submitting"
                    :cols="[
                        { key: 'name', heading: $t('name'), size: 10, sortable: false},
                        { key: 'postcode', heading: $t('postcode'), size: 2, sortable: false}
                    ]"
                    :data="ttrooms"
                    breakpoint="md"
                    :filters="{
                        ...filters,
                        page: filters.page,
                        page_size: filters.page_size,
                        total_count: total_count,
                    }"
                    :searchable="true"
                    :scrollPaginate="true"
                    @refresh="refresh"
                    @toPage="toPage"
                    @selectItem="ttroom => $router.push(`/timetables/rooms/${ttroom.id}`)"
                    :allowRightClick="true"
                    @deleteItem="openDeleteDialog"
                >
                    <!-- Table Header -->
                    <template v-slot:header>
                        
                    </template>

                    <template v-slot:options>
                    </template>
                </Table> 
            </div>
        </div>    
           

	</div>
</template>

<script>
//import InfiniteScroll from "src/components/InfiniteScroll";
import Table from "src/components/Table/Table.vue";

export default {
	components: {
		Table,
	},
	data: function () {
		return {
			dataUrl: `${this.$settings.APIBaseURL}/timetable/ttroom/list`,
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                sort: '',
                order: '',
                status: ''
            },
            total_count: 0,
            loading: true,
            submitting: false,
            ttrooms:[],
		};
	},
	mounted() {
        this.listRooms();
	},
	methods: {
        listRooms(){
            this.submitting = true;
            this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttroom/list`, {
                method: 'POST',
                data: this.filters
            })
            .then((res)=> {
                this.ttrooms = res.results;
                this.filters.page = res.pagination.page
                this.filters.page_size = res.pagination.page_size
                this.filters.total = res.pagination.total
            })
            .finally(()=>{
                this.loading = false;
                this.submitting = false;
            })
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters, page: 1 }
            this.listRooms()
        },
        toPage(pageNo) {
            this.filters.page = pageNo;
            this.listRooms();
        },
        openDeleteDialog(item) {
            this.selectedItem = item;

            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t('delete-{e}-warning',{e: this.$t('room')}),
                cancelBtn: true,
                confirmCallBack: this.removeItem,
            })
        },
        removeItem() {
            if (!this.selectedItem) return ;
            this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttroom/delete`, {
                method: 'POST',
                data: { id: this.selectedItem.id }
            }).then(res => {
                
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting room')
                this.ttrooms = this.ttrooms.filter(el => el.id !== this.selectedItem.id)
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-delete-{e}',{e:this.$t('room')}),
                })
            }).finally(() => {
                this.selectedItem = undefined
            })
        }
	},
};
</script>
